import React from "react";
import SharedLayout from "./SharedLayout";
import "./ContactView.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const ContactView = ({ user, onLoginClick }) => {
  return (
    <SharedLayout user={user} onLoginClick={onLoginClick}>
      <div className="contact-container">
        <h1
          style={{
            textAlign: "center",
            marginBottom: "2rem",
            color: "#2c3e50",
            fontSize: "2rem",
          }}
        >
          Contact Us
        </h1>
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-method">
              <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
              <div className="contact-details">
                <h3>Email Us</h3>
                <p>
                  If you have any questions or inquiries, please feel free to
                  reach out to us at:
                </p>
                <a href="mailto:info@sigmundml.com" className="contact-email">
                  info@sigmundml.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SharedLayout>
  );
};

export default ContactView;
